import "../css/redeem.css"
import Footer from "../components/footer";
import Swal from "sweetalert2";
import { useState } from "react";
import useStore from "../store/zustandstore";
import Navbar from "../components/nav";
import { Jelly } from "ldrs/react";
import { auth } from "../firebase/firebase";
import { Icon } from "@iconify/react";
import logo1 from "../media/whiteFav.png";
import { useNavigate } from "react-router-dom";
import usefbStore from "../store/firebasestore";
import axios from "axios";

function Redeem(){
  const fonMenuDrawer = useStore((s)=> s.fonMenuDrawer)
  const navigate = useNavigate()
  const closeFonMenu = useStore((s)=> s.closeFonMenu)
  const userID = usefbStore((s)=>s.userID);
  const userName = usefbStore((s)=>s.userName)
  const userEmail = usefbStore((s)=>s.userEmail)
  
  // Token configuration
  const BASE_AMOUNT = 10;      // $10 minimum
  const BASE_TOKENS = 30;     // 30 tokens for $5
  const TOKEN_RATE = BASE_TOKENS / BASE_AMOUNT; // 6 tokens per $1
  
  const MIN_PURCHASE = 5;      // Minimum $5
  const MAX_PURCHASE = 500;    // Maximum $500
  
  const [amount, setAmount] = useState("");
  const [tokens, setTokens] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  // ✅ Calculate tokens correctly
  const calculateTokens = (value) => {
    const numValue = parseFloat(value);
    if (isNaN(numValue) || numValue <= 0) {
      setTokens(0);
      return;
    }
    
    // Calculate tokens: amount × rate, then round to nearest whole number
    const calculatedTokens = Math.round(numValue * TOKEN_RATE);
    setTokens(calculatedTokens);
  };
  
  const handleAmountChange = (e) => {
    let value = e.target.value;
    
    // Remove leading zeros
    if (value.startsWith("0") && value.length > 1) {
      value = value.replace(/^0+/, '');
    }
    if(value>500){
 Swal.fire({
        title: "Maximum Limit Exceeded",
        text: `Maximum purchase is $${MAX_PURCHASE} USD per transaction.`,
        icon: "warning",
        timer: 2000,
        showConfirmButton: false,
        toast: true,
        position: "top-end",
      });        return
    }
    
    setAmount(value);
    calculateTokens(value);
  };
  
  // ✅ NEW: Handle key up to limit max amount
  const handleKeyUp = (e) => {
    let value = e.target.value;
    const numValue = parseFloat(value);
    
    if (!isNaN(numValue) && numValue > MAX_PURCHASE) {
      // Show warning
      Swal.fire({
        title: "Maximum Limit Exceeded",
        text: `Maximum purchase is $${MAX_PURCHASE} USD per transaction.`,
        icon: "warning",
        timer: 2000,
        showConfirmButton: false,
        toast: true,
        position: "top-end",
      });
      
      // Cap the value at MAX_PURCHASE
      setAmount(MAX_PURCHASE.toString());
      calculateTokens(MAX_PURCHASE);
    }
  };
  
  const handleBuyTokens = async () => {
    const numAmount = parseFloat(amount);
    // Validation
    if (!amount || isNaN(numAmount)) {
      Swal.fire({
        title: "Invalid Amount",
        text: "Please enter a valid amount.",
        icon: "warning",
        confirmButtonColor: "#6a5acd",
      });
      return;
    }
    if (numAmount < MIN_PURCHASE) {
      Swal.fire({
        title: "Minimum Purchase Required",
        text: `Minimum purchase is $${MIN_PURCHASE} USD (${MIN_PURCHASE * TOKEN_RATE} tokens).`,
        icon: "info",
        confirmButtonColor: "#6a5acd",
      });
      return;
    }
    if (numAmount > MAX_PURCHASE) {
      Swal.fire({
        title: "Maximum Limit Exceeded",
        text: `Maximum purchase is $${MAX_PURCHASE} USD per transaction.`,
        icon: "warning",
        confirmButtonColor: "#6a5acd",
      });
      return;
    }
if(userName && userID){
  try {
    setIsLoading(true);

    // 📦 Prepare form data
    const formData = new FormData();
    formData.append("uid", userID);
    formData.append("name", userName);
    formData.append("amount", numAmount); // Send raw amount (e.g., 50)
    formData.append("payEmail", userEmail); // User's email from your store

    // 🔐 Get Firebase token (for your backend auth)
    const token = await auth.currentUser.getIdToken();

    // 🚀 Send request to your backend
    const resp = await axios.post(
      "https://solaraback-g1bm.onrender.com/redeemTokens", // Use production URL
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const result = resp.data;
    if(result.success === true ){
      Swal.fire({
        title: "Redemption Successful",
        text: `You have successfully redeemed ${tokens} Solara Tokens!`,
        icon: "success",
        confirmButtonColor: "#6a5acd",
      }).then(() => {
        navigate("/dashboard");
      });
    }else if(result.success === false && result.message === "INSUFFICIENT_BALANCE"){
      Swal.fire({
        title: "Insufficient Balance",
        text: "You do not have enough balance to redeem tokens.",
        icon: "warning",
        confirmButtonColor: "#6a5acd",
      });
    }else{
      Swal.fire({
        title: "Redemption Failed",
        text: result.message || "Something went wrong. Please try again.",
        icon: "error",
        confirmButtonColor: "#6a5acd",
      });
    }
    // Reset form (only if not redirecting)
    setAmount("");
    setTokens(0);
    
  } catch (error) {
    console.error("Payment error:", error);
    Swal.fire({
      title: "Payment Failed",
      text: error.response?.data?.message || "Something went wrong. Please try again.",
      icon: "error",
      confirmButtonColor: "#6a5acd",
    });
  } finally {
    setIsLoading(false);
  }
} else {
  return;
}
   
  };
  
  const toAuth = () => {
    navigate("/auth")
  }
  
  const cnclFon = () => {
    closeFonMenu();
  }

  return (
    <>
      <div className="redeemWrap">
        <div className="redeemBox">
          <div className="redeemBoxTop">
            <span className="tokenI">You will receive</span>
            <span className="tokenRec">{tokens.toLocaleString()}</span>
            <span className="tokenIS">Solara Tokens</span>
          </div>
          
          <div className="redeemBoxBtm">
            <div className="rbbWrap">
              <p className="tokenInst">Enter Amount</p>
              <div className="rbbWrapInput">
                <input 
                  type="number" 
                  placeholder={`Min. $${MIN_PURCHASE} (Max. $${MAX_PURCHASE})`}
                  value={amount}
                  onChange={handleAmountChange}
                  onKeyUp={handleKeyUp} // ✅ Added onKeyUp event
                  min={MIN_PURCHASE}
                  max={MAX_PURCHASE}
                  step="1"
                />
              </div>
              
              {/* ✅ Optional: Show current limit status */}
              {amount && parseFloat(amount) > MAX_PURCHASE && (
                <div className="limitWarning">
                  ⚠️ Maximum limit is ${MAX_PURCHASE}
                </div>
              )}
              
              <div className="rbbBtns">
               
                  {!isLoading ? ( <button 
                  onClick={handleBuyTokens}
                  disabled={!amount || parseFloat(amount) < MIN_PURCHASE || parseFloat(amount) > MAX_PURCHASE || isLoading}
                  style={{
                    cursor: (!amount || parseFloat(amount) < MIN_PURCHASE || parseFloat(amount) > MAX_PURCHASE || isLoading) ? "not-allowed" : "pointer"
                  }}
                >   Redeem Tokens     </button>
): (
     <Jelly
                            size="45"
                            speed="1"
                            color="#6a5acd" 
                        ></Jelly>
)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Redeem;